import Entity from '_entities/base/BaseEntity'

export const UnitSchema = {
    name: 'Unit',
    primaryKey: 'id',
    properties: {
        id: { type: 'int' },
        name: { type: 'string' },
    },
}

class Unit extends Entity {
    get schema () {
        return UnitSchema
    }

    static fieldLabels = {
        id: 'ID',
        name: 'Наименование',
    }
}

export default Unit
